﻿export enum eContainerItemLayout {
    horizontal = "horizontal",
    vertical = "vertical",
    absolute = "absolute",
}
export enum eContainerChildAlignment {
    inherit = "inherit",
    stretch = "stretch",
    start = "start",
    center = "center",
    end = "end",
}
export enum eContainerItemAlignment {
    stretch = "stretch",
    start = "start",
    center = "center",
    end = "end",
}
export enum eContainerItemJustify {
    start = "start",
    center = "center",
    end = "end",
}
export enum eScroll {
    none = "none",
    auto = "auto",
    x = "x",
    y = "y",
}
export enum eRelativeSize {
    auto = "auto",
    x1 = "x1",
    x2 = "x2",
    x3 = "x3",
    x4 = "x4",
    x5 = "x5",
    x6 = "x6",
    x7 = "x7",
    x8 = "x8",
    x9 = "x9",
    x10 = "x10",
    x11 = "x11",
    x12 = "x12",
    custom = "custom",
}
export enum ePadding {
    none = "none",
    small = "small",
    medium = "medium",
    large = "large",
}
export enum eColorShade {
    default = "default",
    lighter1 = "lighter1",
    lighter2 = "lighter2",
    lighter3 = "lighter3",
    lighter4 = "lighter4",
    darker1 = "darker1",
    darker2 = "darker2",
    darker3 = "darker3",
    darker4 = "darker4",
}
export enum eBackgroundColor {
    background = "background",
    primary = "primary",
    accent = "accent",
    warning = "warning",
    success = "success",
    input = "input",
    header = "header",
}
export enum eElevation {
    none = "none",
    z1 = "z1",
    z2 = "z2",
    z3 = "z3",
    z4 = "z4",
    z5 = "z5",
    z6 = "z6",
    z7 = "z7",
    z8 = "z8",
}
export enum eRuleType {
    value = "value",
    visibility = "visibility",
    validation = "validation",
    pricing = "pricing",
    message = "message",
    loaded = "loaded",
    submit = "submit",
    pageChanged = "pageChanged",
    tabChanged = "tabChanged",
    expanderChanged = "expanderChanged",
    output = "output",
    action = "action",
    function = "function",
    global = "global",
    globalEvent = "globalEvent",
    safeFunction = "safeFunction",
    naming = "naming",
    field = "field",
    button = "button",
    svgViewer = "svgViewer",
    html = "html",
    dragStart = "dragStart",
    dragMove = "dragMove",
    dragEnd = "dragEnd",
    optionFilter = "optionFilter",
    nested = "nested",
    resize = "resize",
    nestedSetSelected = "nestedSetSelected",
    keyboard = "keyboard",
    manufacture = "manufacture",
    kineticDocumentRules = "kineticDocumentRules",
    layout = "layout",
    configuratorAdded = "configuratorAdded",
    configuratorRemoved = "configuratorRemoved",
    configuratorCopied = "configuratorCopied",
    product = "product",
    workflow = "workflow",
    beforeBuild = "beforeBuild",
    globalDefinition = "globalDefinition",
    quote = "quote",
    scene = "scene",
    sceneLoaded = "sceneLoaded",
    xrEnter = "xrEnter",
    xrExit = "xrExit",
}
export enum eToolbarPosition {
    hidden = "hidden",
    topLeft = "topLeft",
    topRight = "topRight",
    bottomLeft = "bottomLeft",
    bottomRight = "bottomRight",
}
export enum eValidationTiming {
    always = "always",
    onTouched = "onTouched",
}
export enum eViewerMode {
    none = "none",
    media = "media",
    scene = "scene",
}
export enum ePosition {
    left = "left",
    right = "right",
}
export enum eIconStyle {
    none = "none",
    icon = "icon",
    media = "media",
}
export enum eExportType {
    _custom = "_custom",
    pdf = "pdf",
    bmp = "bmp",
    doc = "doc",
    docm = "docm",
    dot = "dot",
    dotm = "dotm",
    dotx = "dotx",
    emf = "emf",
    epub = "epub",
    html = "html",
    jpg = "jpg",
    gif = "gif",
    tiff = "tiff",
    dwf = "dwf",
    edrw = "edrw",
    png = "png",
    odt = "odt",
    rtf = "rtf",
    tif = "tif",
    xaml = "xaml",
    xps = "xps",
    ods = "ods",
    svg = "svg",
    txt = "txt",
    easm = "easm",
    prt = "prt",
    g = "g",
    dwg = "dwg",
    dxf = "dxf",
    sldprt = "sldprt",
    sldasm = "sldasm",
    slddrw = "slddrw",
    sldlfp = "sldlfp",
    x_t = "x_t",
    x_b = "x_b",
    igs = "igs",
    stl = "stl",
    wrl = "wrl",
    u3d = "u3d",
    psd = "psd",
    ai = "ai",
    cgr = "cgr",
    asm = "asm",
    hcg = "hcg",
    hsf = "hsf",
    sat = "sat",
    stp = "stp",
    step = "step",
    vda = "vda",
    neu = "neu",
    iv = "iv",
    slp = "slp",
    eps = "eps",
    catproduct = "catproduct",
    jt = "jt",
    zgl = "zgl",
    xgl = "xgl",
    csv = "csv",
    xml = "xml",
}
export enum eHotspotSource {
    none = "none",
    text = "text",
    media = "media",
    element = "element",
}
export enum eHotspotAttach {
    topLeft = "topLeft",
    top = "top",
    topRight = "topRight",
    left = "left",
    center = "center",
    right = "right",
    bottomLeft = "bottomLeft",
    bottom = "bottom",
    bottomRight = "bottomRight",
}
export enum eHotspotPosition {
    manual = "manual",
    target = "target",
}
export enum eHotspotShape {
    circle = "circle",
    circleWithText = "circleWithText",
    image = "image",
    mesh = "mesh",
    text = "text",
}
export enum eAnimationEasing {
    linear = "linear",
    easeInQuad = "easeInQuad",
    easeOutQuad = "easeOutQuad",
    easeInOutQuad = "easeInOutQuad",
    easeInCubic = "easeInCubic",
    easeOutCubic = "easeOutCubic",
    easeInOutCubic = "easeInOutCubic",
    easeInQuart = "easeInQuart",
    easeOutQuart = "easeOutQuart",
    easeInOutQuart = "easeInOutQuart",
    easeInQuint = "easeInQuint",
    easeOutQuint = "easeOutQuint",
    easeInOutQuint = "easeInOutQuint",
    easeInSine = "easeInSine",
    easeOutSine = "easeOutSine",
    easeInOutSine = "easeInOutSine",
    easeInExpo = "easeInExpo",
    easeOutExpo = "easeOutExpo",
    easeInOutExpo = "easeInOutExpo",
    easeInCirc = "easeInCirc",
    easeOutCirc = "easeOutCirc",
    easeInOutCirc = "easeInOutCirc",
    easeInElastic = "easeInElastic",
    easeOutElastic = "easeOutElastic",
    easeInOutElastic = "easeInOutElastic",
    easeInBack = "easeInBack",
    easeOutBack = "easeOutBack",
    easeInOutBack = "easeInOutBack",
    easeInBounce = "easeInBounce",
    easeOutBounce = "easeOutBounce",
    easeInOutBounce = "easeInOutBounce",
}
export enum eQueryMode {
    none = "none",
    table = "table",
    database = "database",
    array = "array",
    optionFilter = "optionFilter",
    parentOptionFilter = "parentOptionFilter",
}
export enum eOptionFilterSource {
    table = "table",
    database = "database",
    query = "query",
    safeFunction = "safeFunction",
    optionFilter = "optionFilter",
}
export enum eOutputType {
    none = "none",
    word = "word",
    excel = "excel",
    image = "image",
    solidworks = "solidworks",
    inventor = "inventor",
    creo = "creo",
    creo3 = "creo3",
    cadDrawing = "cadDrawing",
    bom = "bom",
    sceneRender = "sceneRender",
    pdf = "pdf",
    salesforce = "salesforce",
    autoCad = "autoCad",
    zip = "zip",
    svg = "svg",
    text = "text",
}
export enum eOutputFieldType {
    wordText = "wordText",
    wordContainer = "wordContainer",
    wordImage = "wordImage",
    wordList = "wordList",
    excelSheet = "excelSheet",
    excelCell = "excelCell",
    excelImage = "excelImage",
    excelTable = "excelTable",
    excelChart = "excelChart",
    cadReplaceComponent = "cadReplaceComponent",
    cadAngleMate = "cadAngleMate",
    cadCoincidentMate = "cadCoincidentMate",
    cadCoordinateSystemMate = "cadCoordinateSystemMate",
    cadDistanceMate = "cadDistanceMate",
    cadPositionConstraint = "cadPositionConstraint",
    cadDimension = "cadDimension",
    cadFeature = "cadFeature",
    cadLibFeature = "cadLibFeature",
    cadCustomProperty = "cadCustomProperty",
    cadComponent = "cadComponent",
    cadDrawingView = "cadDrawingView",
    cadDrawingSheet = "cadDrawingSheet",
    cadDrawingAnnotation = "cadDrawingAnnotation",
    cadDynamicDrawingDimension = "cadDynamicDrawingDimension",
    cadDynamicDrawingAnnotation = "cadDynamicDrawingAnnotation",
    cadDynamicComponent = "cadDynamicComponent",
    cadNestedComponent = "cadNestedComponent",
    cadScaleFeature = "cadScaleFeature",
    cadAnnotation = "cadAnnotation",
    cadText = "cadText",
    cadParameter = "cadParameter",
    cadRepresentation = "cadRepresentation",
    cadPoint = "cadPoint",
    cadLayer = "cadLayer",
    bomMapping = "bomMapping",
    salesForceObject = "salesForceObject",
    cadDrawingDimension = "cadDrawingDimension",
    pdfSection = "pdfSection",
    cadLibReference = "cadLibReference",
    cadLibDimension = "cadLibDimension",
    cadBlock = "cadBlock",
    cadBlockArray = "cadBlockArray",
    zipSection = "zipSection",
}
export enum eSingleOptionBehavior {
    nothing = "nothing",
    disable = "disable",
    hide = "hide",
}
export enum eConfiguratorImageSource {
    none = "none",
    media = "media",
    scene = "scene",
}
export enum eTextColor {
    normal = "normal",
    header = "header",
    primary = "primary",
    accent = "accent",
    error = "error",
    success = "success",
}
export enum eConfiguratorEntityType {
    product = "product",
    quoteHeader = "quoteHeader",
}
export enum eBackground {
    color = "color",
    transparent = "transparent",
    environment = "environment",
}
export enum eSideOrientation {
    frontSide = "frontSide",
    backSide = "backSide",
    doubleSide = "doubleSide",
}
export enum eUvMode {
    planar = "planar",
    box = "box",
    cylindrical = "cylindrical",
    spherical = "spherical",
    useExisting = "useExisting",
}
export enum eMaterialViewMode {
    shaded = "shaded",
    edges = "edges",
    wireframe = "wireframe",
}
export enum eMaterialLocation {
    local = "local",
    global = "global",
    library = "library",
}
export enum eAlphaMode {
    disable = "disable",
    add = "add",
    combine = "combine",
    subtract = "subtract",
    multiply = "multiply",
}
export enum eViewpointType {
    orbit = "orbit",
    firstPerson = "firstPerson",
    overhead = "overhead",
}
export enum eViewpointProjection {
    perspective = "perspective",
    orthographic = "orthographic",
}
export enum eViewpointTargetMode {
    rotation = "rotation",
    point = "point",
    mesh = "mesh",
}
export enum eConnectorPositionMode {
    boundingBox = "boundingBox",
    absolute = "absolute",
    moveAlongSketch = "moveAlongSketch",
}
export enum eDragMode {
    plane = "plane",
    free = "free",
    surface = "surface",
}
export enum eConnectionMode {
    none = "none",
    world = "world",
    screen = "screen",
}
export enum eEasing {
    linear = "linear",
    quadraticIn = "quadraticIn",
    quadraticOut = "quadraticOut",
    quadraticInOut = "quadraticInOut",
    cubicIn = "cubicIn",
    cubicOut = "cubicOut",
    cubicInOut = "cubicInOut",
    quarticIn = "quarticIn",
    quarticOut = "quarticOut",
    quarticInOut = "quarticInOut",
    quinticIn = "quinticIn",
    quinticOut = "quinticOut",
    quinticInOut = "quinticInOut",
    sinusoidalIn = "sinusoidalIn",
    sinusoidalOut = "sinusoidalOut",
    sinusoidalInOut = "sinusoidalInOut",
    exponentialIn = "exponentialIn",
    exponentialOut = "exponentialOut",
    exponentialInOut = "exponentialInOut",
    circularIn = "circularIn",
    circularOut = "circularOut",
    circularInOut = "circularInOut",
    elasticIn = "elasticIn",
    elasticOut = "elasticOut",
    elasticInOut = "elasticInOut",
    backIn = "backIn",
    backOut = "backOut",
    backInOut = "backInOut",
    bounceIn = "bounceIn",
    bounceOut = "bounceOut",
    bounceInOut = "bounceInOut",
}
export enum eCylinderCap {
    none = "none",
    start = "start",
    end = "end",
    both = "both",
}
export enum eJoinType {
    union = "union",
    intersect = "intersect",
    cut = "cut",
}
export enum eShadowQuality {
    low = "low",
    medium = "medium",
    high = "high",
}
export enum eShadowResolution {
    low = "low",
    medium = "medium",
    high = "high",
}
export enum eShadowFilter {
    none = "none",
    simple = "simple",
    advanced = "advanced",
}
export enum eMaterialWorkflow {
    metallicRoughness = "metallicRoughness",
    specularGlossiness = "specularGlossiness",
}
export enum eFeatureCenter {
    barycenter = "barycenter",
    meshPivotPoint = "meshPivotPoint",
}
export enum eJobStatus {
    none = "none",
    waiting = "waiting",
    queued = "queued",
    working = "working",
    complete = "complete",
    failed = "failed",
}
export enum eJobType {
    build = "build",
    render = "render",
    notification = "notification",
    upsertProductsToSfdc = "upsertProductsToSfdc",
    pullSfdcProducts = "pullSfdcProducts",
    submitFromSfdcCpq = "submitFromSfdcCpq",
    completeBuildState = "completeBuildState",
    cleanDb = "cleanDb",
    deployment = "deployment",
    sceneImport = "sceneImport",
    sceneExport = "sceneExport",
    sceneConvert = "sceneConvert",
    completeQuoteProductBuild = "completeQuoteProductBuild",
    configuratorExport = "configuratorExport",
    configuratorImport = "configuratorImport",
}
export enum eEnvironment {
    prod = "prod",
    test = "test",
    dev = "dev",
}
export enum eImportType {
    external = "external",
    kb3d = "kb3d",
}
export enum eQueueMessageType {
    builder = "builder",
    cleanDb = "cleanDb",
    completeBuildState = "completeBuildState",
    notification = "notification",
    render = "render",
    pullSfdcProducts = "pullSfdcProducts",
    upsertProductsToSfdc = "upsertProductsToSfdc",
    submitFromSfdcCpq = "submitFromSfdcCpq",
    deployment = "deployment",
    completeQuoteProductBuild = "completeQuoteProductBuild",
    sceneImport = "sceneImport",
    sceneExport = "sceneExport",
    sceneConvert = "sceneConvert",
}
export enum eMateType {
    fastened = "fastened",
    revolute = "revolute",
    slider = "slider",
    planar = "planar",
    cylindrical = "cylindrical",
    ball = "ball",
    parallel = "parallel",
}
export enum eValidationType {
    error = "error",
    warning = "warning",
    info = "info",
}
export enum eValidationSource {
    snap = "snap",
    configurator = "configurator",
    scene = "scene",
}
export enum eTextureChannel {
    emissive = "emissive",
    albedo = "albedo",
    ambient = "ambient",
    opacity = "opacity",
    reflection = "reflection",
    specular = "specular",
    metallic = "metallic",
    roughness = "roughness",
    glossiness = "glossiness",
    normal = "normal",
    ambientOcclusion = "ambientOcclusion",
    anisotropyTangent = "anisotropyTangent",
    subsurfaceThickness = "subsurfaceThickness",
    clearCoatNormal = "clearCoatNormal",
}
export enum eTextureHorizontalAlign {
    left = "left",
    center = "center",
    right = "right",
}
export enum eTextureVerticalAlign {
    top = "top",
    middle = "middle",
    bottom = "bottom",
}
export enum eTextureFit {
    none = "none",
    stretch = "stretch",
    contain = "contain",
}
export enum eTextureBlendMode {
    normal = "normal",
    multiply = "multiply",
    screen = "screen",
    overlay = "overlay",
    darken = "darken",
    lighten = "lighten",
    hue = "hue",
    saturation = "saturation",
    color = "color",
    luminosity = "luminosity",
    difference = "difference",
    mask = "mask",
    vector = "vector",
}
export enum eTextureWrapAddressMode {
    repeat = "repeat",
    clamp = "clamp",
}
export enum eAnnotationLineStyle {
    solid = "solid",
    dashed = "dashed",
    dotted = "dotted",
    none = "none",
}
export enum eDimensionLineCapStyle {
    none = "none",
    arrow = "arrow",
    line = "line",
}
export enum eDimensionAxis {
    free = "free",
    x = "x",
    y = "y",
    z = "z",
}
export enum eLoadingExperience {
    none = "none",
    fade = "fade",
    spinner = "spinner",
    image = "image",
}
export enum eReflectionType {
    plane = "plane",
    probe = "probe",
}
export enum eRenderMode {
    shaded = "shaded",
    wireframe = "wireframe",
    edge = "edge",
    hiddenEdges = "hiddenEdges",
}
export enum eTextureSamplingMode {
    nearest = "nearest",
    bilinear = "bilinear",
    trilinear = "trilinear",
}
export enum eAxis {
    x = "x",
    y = "y",
    z = "z",
}
export enum eSketchPathType {
    points = "points",
    arcThrough3Points = "arcThrough3Points",
    centerRadiusCircle = "centerRadiusCircle",
    catmullRom = "catmullRom",
    cubicBezier = "cubicBezier",
    quadraticBezier = "quadraticBezier",
    hermite = "hermite",
}
export enum eFilterControl {
    none = "none",
    text = "text",
    select = "select",
    multiSelect = "multiSelect",
    dateRange = "dateRange",
    numberRange = "numberRange",
    suggest = "suggest",
    checkbox = "checkbox",
}
export enum eFilterSource {
    none = "none",
    enum = "enum",
    properties = "properties",
    users = "users",
    states = "states",
    configurators = "configurators",
    fields = "fields",
    customers = "customers",
    roles = "roles",
    productSorts = "productSorts",
    manufacturers = "manufacturers",
    attributes = "attributes",
    suggestContacts = "suggestContacts",
    suggestCustomers = "suggestCustomers",
    suggestQuotes = "suggestQuotes",
    suggestProducts = "suggestProducts",
    headerFields = "headerFields",
}
export enum eFilterType {
    property = "property",
    fieldValue = "fieldValue",
    sort = "sort",
    attribute = "attribute",
    headerValue = "headerValue",
}
export enum eFieldType {
    text = "text",
    number = "number",
    boolean = "boolean",
    color = "color",
    date = "date",
    upload = "upload",
    textArray = "textArray",
    numberArray = "numberArray",
    colorArray = "colorArray",
}
